import { get as _get } from 'lodash'

export default function getAuthenticatedRedirectPath(currentUser, locationState = null) {
  const previousPath = _get(locationState, 'from')
  if (previousPath) {
    return previousPath
  }

  const facilitiesUsers = currentUser && Array.isArray(currentUser.facilitiesUsers) ? currentUser.facilitiesUsers : []
  const coachFacilitiesUser = facilitiesUsers.find((user) => user.admin || user.coach)

  if (coachFacilitiesUser) return `/facilities/${coachFacilitiesUser.facility.id}/calendar`

  const isParent = !!_get(currentUser, 'students.length')
  if (isParent) return `/guardians/${currentUser.id}/students`

  return '/'
}
